import { useSearchParams } from "react-router-dom";
import { AlertTriangle } from "lucide-react";

export default function SubscriptionLocked() {
  const [params] = useSearchParams();
  const message = params.get("msg") || "Aapka subscription expire ho gaya hai.";

  return (
    <div className="w-full min-h-full bg-gray-50 flex items-center justify-center px-4 py-16">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-sm border p-8 text-center">
        <div className="w-16 h-16 rounded-full bg-red-100 flex items-center justify-center mx-auto mb-4">
          <AlertTriangle className="text-red-600" size={32} />
        </div>
        <h1 className="text-xl font-bold text-gray-900 mb-2">Payment Due / Subscription Expired</h1>
        <p className="text-sm text-gray-600 mb-6">{decodeURIComponent(message)}</p>
        <p className="text-xs text-gray-400">
          Is feature ko dobara use karne ke liye kripya apni team/admin se contact karke renewal karayein.
        </p>
      </div>
    </div>
  );
}